import React from "react";
import tw from "twin.macro";
import ProjectShowCaseSingle from "components/project-showcase/ProjectShowCaseSingle";
import SystemDevelopmentMobleView from "components/services/SystemDevelopmentMobleView";
const Content = tw.div`max-w-screen-xl mx-auto`;
export default ({ isXs = false }) => {
  return (
    <>
      <Content>
        <SystemDevelopmentMobleView />
      </Content>

      <div style={{ marginTop: "-50px" }}>
        <ProjectShowCaseSingle />
      </div>
    </>
  );
};
